import React from 'react';

import CircleDiagram from './CircleDiagram';

const CoverPage = ({ firstName, lastName, date }) => {
	return (
		<div className={'ohs-cover'}>
			<div className={'ohs-cover__header-bar'}>
				<span className={'ohs-cover__header-title'}>ORGANIZATIONAL HEALTH REPORT</span>
			</div>

			<div className={'ohs-cover__body ohs-content-padding'}>
				<div className={'ohs-cover__title'}>
					<span className="highlighted">T</span>HE <br/> <span className="highlighted">A</span>dvantage
				</div>

				<div className={'ohs-cover__separator'} />

				<div className={'ohs-cover__info'}>
					<div className={'ohs-cover__name'}>{firstName} {lastName}</div>
					<div className={'ohs-cover__date'}>{date}</div>
				</div>

				<div className={'ohs-cover__diagram'}>
					<CircleDiagram size={440} />
				</div>
			</div>
		</div>
	);
};

export default CoverPage;
